import actions from "./actions";
import endpoints from "../api/endpoints";
import { updateVideos } from "../../../Pages/Video/VideoActions";
import { actions as videoAssociationActions } from "../videoAssociations";

const { doVideoDetailRequest, doVideoDetailSuccess, doVideoDetailFailure } =
  actions;

const fetchVideoDetail = (videoId) => (dispatch) => {
  dispatch(doVideoDetailRequest());
  $.ajax({
    method: "get",
    url: endpoints.videoDetail.replace("{{videoId}}", videoId),
    success(data, statusText, { status }) {
      dispatch(doVideoDetailSuccess({ data, statusText, status }));
    },
    error(xhr) {
      dispatch(doVideoDetailFailure(xhr));
    },
  });
};

const updateVideoDetail =
  (videoId, payload, isRemove = false) =>
  (dispatch, getState) => {
    dispatch(doVideoDetailRequest());
    //const { store } = window;
    const globalState = getState();
    const { videos, videoData } = globalState || {};
    $.ajax({
      method: "put",
      url: endpoints.videoDetail.replace("{{videoId}}", videoId),
      data: payload,
      success(data, statusText, { status }) {
        dispatch(
          videoAssociationActions.doVideoAssociationsSuccess({
            data,
            statusText,
            status,
          })
        );
        if (!isRemove) {
          const newVideos = videos.map((el) => {
            const { video } = el;
            if (video._id === videoId) {
              return data;
            }
            return el;
          });
          dispatch(updateVideos(newVideos, videoData));
        }
        dispatch(doVideoDetailSuccess({ data, statusText, status }));
      },
      error(xhr) {
        dispatch(doVideoDetailFailure(xhr));
      },
    });
  };

export default {
  fetchVideoDetail,
  updateVideoDetail,
};
